/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from 'react';
import Error from '../../components/Error/Error';
import CloudDisconnected from '../../components/Error/icons/CloudDisconnected';
import { useIntl } from 'react-intl';

const PageRenderError = () => {
    const intl = useIntl();
    return (
        <Error
            refresh
            icon={<CloudDisconnected />}
            title={intl.formatMessage({ id: 'lcp.common.pageRenderError.title' })}
            descPrimary={intl.formatMessage({ id: 'lcp.common.pageRenderError.desc.primary' })}
            descSecondary={intl.formatMessage({ id: 'lcp.common.pageRenderError.desc.secondary' })}
        />
    );
};

export default PageRenderError;
